import AprendizagemIcon from 'assets/icons/AprendizagemIcon';
import BusIcon from 'assets/icons/BusIcon';
import FileIcon from 'assets/icons/fileIcon';
import IndicesIcon from 'assets/icons/IndicesIcon';
import InfosIniciaisIcon from 'assets/icons/infosIniciaisIcon';
import LetterAIcon from 'assets/icons/LetterAIcon';
import RevisaoFinalizacaoIcon from 'assets/icons/revisaoFinalizacaoIcon';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto, RevisaoDTO, StatusEtapa } from 'models/projeto';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import Step from '../step/step';
import styles from './stepSidebar.scss';
const { rootClassName } = styles;

const icons = {
  [EtapaProjeto.infosIniciais]: <InfosIniciaisIcon />,
  [EtapaProjeto.curriculo]: <InfosIniciaisIcon />,
  [EtapaProjeto.expedicao]: <BusIcon />,
  [EtapaProjeto.tituloDoProjeto]: <LetterAIcon />,
  [EtapaProjeto.indices]: <IndicesIcon />,
  [EtapaProjeto.mobilizacao]: <FileIcon />,
  [EtapaProjeto.aprendizagem]: <AprendizagemIcon />,
  [EtapaProjeto.indiceFinal]: <IndicesIcon />,
  [EtapaProjeto.revisao]: <RevisaoFinalizacaoIcon />,
};

export const getStatusStep = (
  etapa: EtapaProjeto,
  avaliacoes?: RevisaoDTO[]
) => {
  const av = avaliacoes?.find(
    (a) => a.etapa === Object.values(EtapaProjeto).indexOf(etapa)
  );
  if (
    etapa === EtapaProjeto.revisao &&
    avaliacoes?.filter((aV) => aV.status === StatusEtapa.Aprovada).length ===
      Object.values(EtapaProjeto).length - 1
  ) {
    return StatusEtapa.Aprovada;
  }
  if (av) {
    return av.status as StatusEtapa;
  }
  return StatusEtapa.SemPreenchimento;
};

export default function StepSidebar() {
  const { state, validator, changeEtapa } = useContext(ProjetosContext);

  const { stepSlugName } = useParams<{
    stepSlugName: string;
  }>();

  return (
    <div className={rootClassName}>
      {Object.values(EtapaProjeto).map((etapa) => {
        return (
          <Step
            flgInfantil={state.projeto.flgInfantil!}
            status={getStatusStep(etapa, state.projeto.avaliacoes)}
            key={etapa}
            id={etapa}
            icon={icons[etapa]}
            active={stepSlugName === etapa}
            onClick={() => {
              if (Object.values(state.etapasLoading).every((e) => !e)) {
                changeEtapa(etapa);
              }
            }}
            disabled={validator?.etapaIsDisabled[etapa]}
          />
        );
      })}
    </div>
  );
}
